import { createStore } from 'vuex'
import auth from './module/auth'
import clients from './module/clients'
import locale from './module/locale'

const store = createStore({
    modules : {
        auth,
        clients,
        locale
    }
})

export default store
